"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCMSErrorEvent = exports.checkErrorEventObj = exports.createErrorEventObject = exports.ERROR_REQUIRED_KEYS = exports.CONTENT = exports.THEMES = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const bit_utils_log_utils_1 = require("@gcloud-npm/bit.utils.log-utils");
const bit_unifiedicons_svg_icon_loader_1 = require("@gcloud-npm/bit.unifiedicons.svg-icon-loader");
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
/* THEMES */
const Beach_1 = __importDefault(require("./Themes/Beach/Beach"));
const Loading_1 = __importDefault(require("./Themes/Loading"));
const NetworkError_1 = __importDefault(require("./Themes/NetworkError"));
/* CONTENT */
const InfoContent_1 = __importStar(require("./Content/InfoContent"));
const Alert_1 = __importDefault(require("./Content/Alert"));
require("./Stopper.scss");
exports.THEMES = {
    BEACH: 'beach',
    EMPTY: 'empty',
    LOADING: 'loading',
    NETWORK_ERROR: 'networkError',
};
exports.CONTENT = {
    NOT_FOUND: 'NotFound',
    ERROR: 'FatalError',
    ERROR_ALERT: 'ErrorAlert',
    INFO_ALERT: 'InfoAlert',
    NONE: 'None',
};
exports.ERROR_REQUIRED_KEYS = ['eventType', 'errorDetail', 'errorOrigin'];
/**
 * Crea el objeto con la estructura adecuada para un evento de componente de métricas
 * @param {String} eventType
 * @param {String} eventType
 * @param {String} errorDetail
 * @param {String} errorOrigin
 */
const createErrorEventObject = (inputObj) => {
    const finalRes = Object.assign({ event: 'cms-error' }, inputObj);
    const normalizedStructure = (0, bit_utils_common_1.applyTransform2Object)([
        {
            type: 'string',
            method: (str) => (0, bit_utils_common_1.normalizeString)((0, bit_utils_common_1.toKebabCase)(str)),
        },
    ], (keyName) => (0, bit_utils_common_1.toKebabCase)(keyName), finalRes);
    return normalizedStructure;
};
exports.createErrorEventObject = createErrorEventObject;
const checkErrorEventObj = (taggingInfo) => {
    let res = true;
    exports.ERROR_REQUIRED_KEYS.forEach((key) => {
        if (typeof taggingInfo[key] === 'undefined') {
            res = false;
        }
    });
    return res;
};
exports.checkErrorEventObj = checkErrorEventObj;
const sendCMSErrorEvent = (inputObj) => {
    const checkObj = (0, exports.checkErrorEventObj)(inputObj);
    const object = (0, exports.createErrorEventObject)(inputObj);
    try {
        if (checkObj) {
            window.nookInfoExchange.sendMessage('Metrics', object);
        }
        else {
            (0, bit_utils_log_utils_1.errorLog)('TaggingInfo is no properly defined', '[checkEventObj] no right event structure');
        }
    }
    catch (err) {
        // TODO monirorizar donde toque.
    }
};
exports.sendCMSErrorEvent = sendCMSErrorEvent;
const themeLoader = (theme, retry) => {
    switch (theme) {
        case exports.THEMES.EMPTY:
            return null;
        case exports.THEMES.LOADING:
            return react_1.default.createElement(Loading_1.default, null);
        case exports.THEMES.NETWORK_ERROR:
            return react_1.default.createElement(NetworkError_1.default, { retry: retry });
        case exports.THEMES.BEACH:
        default:
            return react_1.default.createElement(Beach_1.default, null);
    }
};
const getInPageErrorDetails = (contentProps) => {
    const { errorName, errorCode, errorDetails } = contentProps;
    let errorDetail = `${errorName}`;
    if (errorCode) {
        errorDetail = `${errorDetail}-${errorCode}`;
    }
    if (errorDetails) {
        errorDetail = `${errorDetail}-${errorDetails}`;
    }
    return errorDetail;
};
const contentLoader = (content, contentProps, projectId, taggingInfo) => {
    let contentToLoad = null;
    let errorDetail = '';
    const finalTaggingInfo = Object.assign(Object.assign({}, taggingInfo), { componentVariation: taggingInfo.componentVariation || 'all', componentProduct: taggingInfo.componentProduct || '', componentName: taggingInfo.componentName || `Stopper;${content}` });
    switch (content) {
        case exports.CONTENT.ERROR:
            contentToLoad = (react_1.default.createElement(InfoContent_1.default, { kind: InfoContent_1.CONTENT_KIND.ERROR, taggingInfo: finalTaggingInfo }));
            errorDetail = 'FatalError-500-ErrorJs';
            break;
        case exports.CONTENT.ERROR_ALERT: {
            contentToLoad = (react_1.default.createElement(Alert_1.default, { iconColor: bit_unifiedicons_svg_icon_loader_1.COLOR.PIPPER, iconId: bit_unifiedicons_svg_icon_loader_1.ICONS_ID.Alerta, errorToPrint: contentProps, taggingInfo: finalTaggingInfo }));
            errorDetail = getInPageErrorDetails(contentProps);
            break;
        }
        case exports.CONTENT.INFO_ALERT:
            contentToLoad = (react_1.default.createElement(Alert_1.default, { iconColor: bit_unifiedicons_svg_icon_loader_1.COLOR.BLUE, iconId: bit_unifiedicons_svg_icon_loader_1.ICONS_ID.Informacion, errorToPrint: contentProps, taggingInfo: finalTaggingInfo }));
            errorDetail = getInPageErrorDetails(contentProps);
            break;
        case exports.CONTENT.NONE:
            contentToLoad = null;
            break;
        default:
            contentToLoad = react_1.default.createElement(InfoContent_1.default, { taggingInfo: finalTaggingInfo });
            errorDetail = 'NotFound-404';
            break;
    }
    (0, exports.sendCMSErrorEvent)({
        eventType: 'error-page',
        errorDetail,
        errorOrigin: projectId,
    });
    return contentToLoad;
};
/* iF CHILDREN IS DEFINED WE IGNORE CONTENT */
const Stopper = ({ children, theme, content, contentProps, projectId, taggingInfo, contextData, retry, }) => {
    const finalContent = children ? null : content;
    console.log('status: ', { theme, content });
    return (react_1.default.createElement("div", { className: `Stopperito ${content} ${theme}` },
        react_1.default.createElement("div", { className: "childrenContainer" },
            children && children,
            !children &&
                finalContent &&
                contentLoader(finalContent, contentProps, projectId, taggingInfo, contextData)),
        themeLoader(theme, retry)));
};
Stopper.propTypes = {
    /**
     * {
     *  "info": "Establece los elementos que forman el componente",
     *  "kind": "both",
     *  "beautifulName": "Elememtos del componente"
     * }
     */
    children: prop_types_1.default.node,
    /**
     * {
     *  "info": "Establece el contenido del componente",
     *  "kind": "both",
     *  "beautifulName": "Elememtos del componente"
     * }
     */
    content: prop_types_1.default.oneOf(Object.values(exports.CONTENT)),
    /**
     * {
     *  "info": "Define el tema del componente en el array THEMES",
     *  "kind": "both",
     *  "beautifulName": "Elememtos del componente"
     * }
     */
    theme: prop_types_1.default.oneOf(Object.values(exports.THEMES)),
    /**
     * {
     *  "info": "Define el nombre del proyecto desde el que se pinta la página de error",
     *  "kind": "both",
     *  "beautifulName": "Nombre del proyecto"
     * }
     */
    projectId: prop_types_1.default.string,
    /**
     * {
     *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
     *  "kind": "both",
     *  "beautifulName": "Propiedades tagueo"
     * }
     */
    taggingInfo: prop_types_1.default.object,
    /**
     * {
     *  "info": "Props passed to content, used to customize the information that is showed",
     *  "kind": "both",
     *  "beautifulName": "Propiedades contenido"
     * }
     */
    contentProps: prop_types_1.default.shape({
        button: prop_types_1.default.shape({
            label: prop_types_1.default.string,
            url: prop_types_1.default.string,
        }),
        title: prop_types_1.default.string,
        msg: prop_types_1.default.arrayOf(prop_types_1.default.string),
        phone: prop_types_1.default.string,
        errorName: prop_types_1.default.string,
        errorCode: prop_types_1.default.string,
        errorDetails: prop_types_1.default.string,
    }),
    /**
     * {
     *  "info": "Sirve para la pantalla de network error cuando no tienes conexión",
     *  "kind": "both",
     *  "beautifulName": "reintentar"
     * }
     */
    retry: prop_types_1.default.func,
};
Stopper.defaultProps = {
    children: null,
    theme: exports.THEMES.BEACH,
    content: exports.CONTENT.NOT_FOUND,
    projectId: 'unknown',
    taggingInfo: {},
    contentProps: {},
    contextData: null,
    retry: null,
};
exports.default = Stopper;
//# sourceMappingURL=index.js.map